/* BLACK ROBE - Studio White theme scripts */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.BR && window.BR.moneyFormat ? window.BR.moneyFormat : '{{amount}} EGP';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  };

  /* ---------- Drawers ---------- */

  var lastFocus = null;

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('[data-drawer-close], a, button, input');
    if (focusable) focusable.focus();
  }

  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.drawer.is-open');
      if (open) closeDrawer(open);
    }
  });

  /* ---------- Quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker ---------- */

  function initVariants(root) {
    var form = root.querySelector('[data-product-form]');
    var dataEl = root.querySelector('[data-variant-json]');
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var stockEl = root.querySelector('[data-stock]');

    function selectedOptions() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function render() {
      var opts = selectedOptions();
      var v = matchVariant(opts);

      // Reflect chosen value next to each option label
      Array.prototype.forEach.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var out = group.parentNode.querySelector('.opt__value');
        var checked = group.querySelector('input:checked');
        if (out && checked) out.textContent = checked.value;
      });

      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.innerHTML = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to bag' : 'Sold out';
      }

      if (stockEl) {
        stockEl.className = 'stock';
        var label = 'In stock, ready to ship';
        if (!v.available) {
          stockEl.classList.add('stock--out');
          label = 'Sold out';
        } else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
          stockEl.classList.add('stock--low');
          label = 'Low stock - only ' + v.inventory_quantity + ' left';
        }
        stockEl.innerHTML = '<span class="stock__dot" aria-hidden="true"></span><span>' + label + '</span>';
      }

      // Keep the URL shareable
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) render();
    });

    render();
  }

  /* ---------- Cart ---------- */

  function refreshCartCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function loadCartDrawer() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var target = document.querySelector('[data-cart-drawer-body]');
        if (!target) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-body]');
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!document.querySelector('[data-cart-drawer]')) return; // no drawer: normal POST

    e.preventDefault();
    var submit = form.querySelector('[data-add-button]');
    var original = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Adding...'; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || data.message);
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        return loadCartDrawer();
      })
      .then(function () {
        openDrawer('cart-drawer');
      })
      .catch(function (err) {
        alert(err.message || 'Sorry, that could not be added to your bag.');
      })
      .finally(function () {
        if (submit) { submit.disabled = false; submit.textContent = original || 'Add to bag'; }
      });
  });

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        if (document.querySelector('[data-cart-drawer-body]')) return loadCartDrawer();
        window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-line-remove'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) changeLine(q.getAttribute('data-line-qty'), parseInt(q.value, 10) || 1);
  });

  /* ---------- Reveal on scroll ---------- */

  function initReveal() {
    var items = document.querySelectorAll('.reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  /* ---------- Boot ---------- */

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-root]'), initVariants);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
})();
